import React from 'react';
import { Routes, Route, Navigate, NavLink, } from "react-router-dom-v5-compat";

import CanvasIntegrationContainer from '../components/canvas/container'
import GoogleIntegrationContainer from '../components/google/container'
import CleverIntegrationContainer from '../components/clever/container'
import ClasslinkIntegrationContainer from '../components/classlink/container'

const IntegrationsContainer = (sharedProps) => {
  const { accessType, user, } = sharedProps

  return (
    <main className='integrations-container white-background-accommodate-footer'>
      <header className="reports-header">
        <div className="container">
          <h1>Integrations</h1>
          <nav>
            <NavLink className="focus-on-light" to='/teachers/premium_hub/integrations/canvas'>Canvas</NavLink>
            <NavLink className="focus-on-light" to='/teachers/premium_hub/integrations/google'>Google Classroom</NavLink>
            <NavLink className="focus-on-light" to='/teachers/premium_hub/integrations/clever'>Clever</NavLink>
            <NavLink className="focus-on-light" to='/teachers/premium_hub/integrations/classlink'>ClassLink</NavLink>
          </nav>
        </div>
      </header>
      <Routes>
        <Route element={<CleverIntegrationContainer accessType={accessType} />} path='/teachers/premium_hub/integrations/clever' />
        <Route element={<GoogleIntegrationContainer accessType={accessType} />} path='/teachers/premium_hub/integrations/google' />
        <Route element={<CanvasIntegrationContainer accessType={accessType} user={user} />} path='/teachers/premium_hub/integrations/canvas' />
        <Route element={<Navigate to="/teachers/premium_hub/integrations/canvas" />} path='/teachers/premium_hub/integrations' />
        <Route element={<ClasslinkIntegrationContainer accessType={accessType} user={user} />} path='/teachers/premium_hub/integrations/classlink' />
      </Routes>
    </main>
  )
}

export default IntegrationsContainer
